import { render } from "./notification-dialog.vue?vue&type=template&id=7cefa362&scoped=true"
import script from "./notification-dialog.vue?vue&type=script&lang=js"
export * from "./notification-dialog.vue?vue&type=script&lang=js"

import "./notification-dialog.vue?vue&type=style&index=0&id=7cefa362&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cefa362"]])

export default __exports__